<template>
    <div id="directory" class="docker__item">
      <van-cell is-link @click="showPopup">
        <van-icon name="apps-o" size=".6rem" />
        <span class="docker__item__text">目录</span>
      </van-cell>
      <van-popup
        v-model:show="show"
        :style="{height:'80%',width: '100% '}"
      >
        <p class="edition">第{{pageNum}}版：{{pageName}}</p>
        <div
         v-for="(item, index) in directoryList"
         :key="index"
         @click="changeOneNewsData(index, item.title)"
        >
          <router-link :to="`/content/${item.id}/${item.accessName}/${pageId}/${pageDate}`">
          <div :class="activeIndex===index?'active':'edition__list__item'">{{item.title}}</div>
        </router-link>
        </div>
      </van-popup>
    </div>
</template>
<script>
import { ref, computed, watch, onBeforeUpdate } from 'vue'
import { get } from '../../utils/request'
import { useStore } from 'vuex'
export default {
  name: 'Directory',
  props: {
    newsId: String
  },
  setup (props, { emit }) {
    const store = useStore()
    const directoryData = ref([])
    const newDirectoryList = ref([])
    const newsId = ref('')
    const accessName = ref('')
    const pageId = ref('')
    const pageNum = ref('')
    const pageName = ref('')
    const pageDate = ref('')
    const directoryIndex = ref()
    const pageList = computed(() => store.state.pageList)
    const directoryList = computed(() => store.state.directoryList)
    const defaultList = computed(() => store.state.defaultList)
    const activeIndex = computed(() => store.state.activeIndex)
    emit('getDirectoryList', directoryList)
    const getDirectoryList = async () => {
      if (pageList.value.id !== undefined) {
        newsId.value = pageList.value.id
        accessName.value = pageList.value.accessName
      } else {
        newsId.value = defaultList.value.id
        accessName.value = defaultList.value.accessName
      }
      newDirectoryList.value = computed(() => store.state.directoryList)
      // const url = `/tableNewsController/getTableNewsList?ids=${newsId.value}&accessName=${accessName.value}`
      const url = `/tableNewsController/notRemovalNewsList?ids=${newsId.value}&accessName=${accessName.value}`
      const result = await get(url)
      directoryData.value = result.list
      store.dispatch('getDirectoryList', directoryData)
    }
    onBeforeUpdate(() => {
      console.log(pageList.value)
      if (pageList.value.pageNum !== undefined) {
        pageId.value = pageList.value.id
        pageNum.value = pageList.value.pageNum
        pageName.value = pageList.value.pageName
        pageDate.value = pageList.value.pageDate
      } else {
        pageId.value = defaultList.value.id
        pageNum.value = defaultList.value.pageNum
        pageName.value = defaultList.value.pageName
        pageDate.value = defaultList.value.pageDate
      }
    })
    watch(
      () => [pageList.value.id, defaultList.value.id],
      () => {
        getDirectoryList()
      }
    )
    const changeOneNewsData = (index, title) => {
      show.value = false
      store.dispatch('getContentIndex', index)
      store.dispatch('getContentTitle', title)
      store.dispatch('getActiveIndex', index)
      directoryIndex.value = index
    }
    const show = ref(false)
    const showPopup = () => {
      show.value = true
    }
    return {
      show,
      pageId,
      pageNum,
      pageName,
      pageDate,
      activeIndex,
      showPopup,
      directoryList,
      newDirectoryList,
      pageList,
      defaultList,
      changeOneNewsData
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../style/variables.scss';
.docker__item {
    flex: 1;
    text-align: center;
    color: $content-fontcolor;
    &__text {
      font-size: .45rem;
      margin-bottom: 1rem;
    }
    .edition {
      color: #e51c23;
      line-height: 1rem;
      font-size: .4rem;
      margin:0;
    }
    .edition__list__item{
      color: #666666;
      font-size: .4rem;
      text-align: left;
      padding: 0 .3rem;
      line-height: 1rem;
      border-bottom: .0005rem solid #ddd;
    }
    .active{
      color: #e51c23;
      font-size: .4rem;
      text-align: left;
      padding: 0 .3rem;
      line-height: 1rem;
      border-bottom: .0005rem solid #ddd;
    }
  }
</style>
